module.exports = __webpack_public_path__ + "static/media/share-fb.9396e096.svg";